import { z } from 'zod'

export const ItemSelectOptionSchema = z
  .object({
    id: z.number(),
    code: z.string(),
    name: z.string(),
    unit: z.string().default('pcs'),
    canBePurchased: z.boolean(),
    canBeManufactured: z.boolean(),
    canBeUsedInBom: z.boolean(),
    canBeSold: z.boolean(),
    isMoldTracking: z.boolean(),
    isLotTracking: z.boolean(),
    type: z.string().nullable(),
    category: z.string().nullable(),
  })
  .transform((data) => {
    return {
      ...data,
      label: `${data.code} - ${data.name}`,
      value: data.id.toString(),
    }
  })

export type ItemSelectOption = z.infer<typeof ItemSelectOptionSchema>

export const ItemSelectOptionsSchema = z.array(ItemSelectOptionSchema)

export type ItemSelectOptions = z.infer<typeof ItemSelectOptionsSchema>

export const ItemBomOptionSchema = z.object({
  id: z.number(),
  code: z.string(),
  isDefault: z.boolean(),
})

export type ItemBomOptionModel = z.infer<typeof ItemBomOptionSchema>

export const ItemDetailOptionSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  unit: z.string(),
  canBePurchased: z.boolean(),
  canBeManufactured: z.boolean(),
  canBeUsedInBom: z.boolean(),
  canBeSold: z.boolean(),
  isMoldTracking: z.boolean(),
  isLotTracking: z.boolean(),
  type: z.string().nullable(),
  category: z.string().nullable(),
  boms: z.array(ItemBomOptionSchema),
})

export type ItemDetailOptionModel = z.infer<typeof ItemDetailOptionSchema>

export const BomComponentOptionSchema = z.object({
  id: z.number(),
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  qty: z.number(),
})

export type BomComponentOptionModel = z.infer<typeof BomComponentOptionSchema>

export const BomDetailOptionSchema = z.object({
  id: z.number(),
  code: z.string(),
  isDefault: z.boolean(),
  components: z.array(BomComponentOptionSchema),
})

export type BomDetailOptionModel = z.infer<typeof BomDetailOptionSchema>
